import { createBulkOrderApiCall } from "./api";
import { parseBulkOrderResponse } from "./responseHandler";
import { errorToast, successToast } from "../../app/common/util/genericUtils";
import { reportError } from "../../app/common/util/sentryConfig";
import { closeModal } from "../modal/modalActions";

export const createBulkOrder = (file) => async (dispatch) => {
  try {
    const response = await createBulkOrderApiCall(file);
    const parsed = parseBulkOrderResponse(response && response.data);

    if (parsed.success) {
      const queuedText =
        parsed.ordersQueued != null
          ? ` ${parsed.ordersQueued} order${
              parsed.ordersQueued === 1 ? "" : "s"
            } queued.`
          : "";
      successToast("Success", `${parsed.uiMessage}${queuedText}`);
      dispatch(closeModal());
      return parsed;
    }

    errorToast("Error", parsed.uiMessage);
    return parsed;
  } catch (error) {
    const apiPayload = error.response && error.response.data;

    if (apiPayload && apiPayload.response_code != null) {
      const parsed = parseBulkOrderResponse(apiPayload);
      errorToast("Error", parsed.uiMessage);
      return parsed;
    }

    const message =
      (apiPayload && (apiPayload.ui_message || apiPayload.message)) ||
      error.message ||
      "Failed to create bulk orders";
    errorToast("Error", message);
    reportError(error);
    return {
      success: false,
      uiMessage: message,
      fileError: null,
      validationErrors: [],
    };
  }
};
